import { api } from './client';

// White-label logo per tenant (go-api internal/handlers/branding_handlers.go).
// The reads are public so the sign-in page can show it; the server also
// takes the tenant from a tenant subdomain.

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export interface BrandingView {
  has_logo: boolean;
  updated_at?: string;
}

/** Accepted by the server; checked there by content, not by name. */
export const LOGO_ACCEPT = 'image/png,image/jpeg,image/webp';
export const LOGO_MAX_BYTES = 512 * 1024;

export const brandingApi = {
  get: async (tenantSlug: string | null): Promise<BrandingView> => {
    const q = tenantSlug ? `?tenant=${encodeURIComponent(tenantSlug)}` : '';
    const res = await fetch(`${API_BASE}/branding${q}`);
    if (!res.ok) return { has_logo: false };
    return res.json();
  },
  upload: (file: File) => {
    const form = new FormData();
    form.append('logo', file);
    return api
      .put<BrandingView>('/branding/logo', form, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((r) => r.data);
  },
  remove: () => api.delete<BrandingView>('/branding/logo').then((r) => r.data),
};

/** The logo's URL; the version busts the five-minute cache after a change. */
export function logoUrl(tenantSlug: string | null, version?: string): string {
  const q = new URLSearchParams();
  if (tenantSlug) q.set('tenant', tenantSlug);
  if (version) q.set('v', version);
  const qs = q.toString();
  return `${API_BASE}/branding/logo${qs ? `?${qs}` : ''}`;
}
